import { actionGenerator, IReduxAction } from '../../utils/actions';

export const OFFER_VALIDATION_SUCCESS = 'PUBLISH_INFO :: OFFER_VALIDATION_SUCCESS';

export type TOfferValidationSuccessAction = IReduxAction<typeof OFFER_VALIDATION_SUCCESS>;

export const offerValidationSuccess = actionGenerator<typeof OFFER_VALIDATION_SUCCESS>(OFFER_VALIDATION_SUCCESS);
